import { createApp } from 'vue'
import App from './App.vue'

import router from './router';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import ElementPlus from 'element-plus'
import zhCn from '@assets/js/el-plus-locale-zhcn'

import 'element-plus/dist/index.css'
import '@assets/css/reset.css'
// 全局引入字体图标icon
import "@/assets/font/iconfont.css";

import "tailwindcss/tailwind.css"

//引入自定义图片懒加载
import lazy from './lazy'
import { installGlobalImageFallback } from '@utils/imageFallback'


import { createPinia } from 'pinia';
import {
    clearStoragePreservingRememberedLogin,
    normalizeAuthCache,
} from "@utils/user";

const pinia = createPinia();

installGlobalImageFallback();

// 启动时做一次鉴权缓存修复（token 1 年过期适配）
normalizeAuthCache();


(function() {
    window.addEventListener('storage', function(event) {
        if (sessionStorage.getItem("isLogin") == "true") {
            if (event.key == 'getSessionStorage') {
                // 已存在的标签页会收到这个事件
                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
                localStorage.removeItem('sessionStorage');
            }
        } else {
            if (event.key == 'sessionStorage' && event.newValue && !sessionStorage.length) {
                // 新开启的标签页会收到这个事件
                let data = JSON.parse(event.newValue);
                for (let key in data) {
                    sessionStorage.setItem(key, data[key]);
                }
                location.reload();
            }
        }
    });
    // 这个调用能触发目标事件，从而达到共享数据的目的
    localStorage.setItem('getSessionStorage', Date.now());
})();

indexedDB.open("modelList").onsuccess = function(e) {
    const db = e.target.result;
    if (!db.objectStoreNames.contains("model")) {
        db.close(); // 使用后关闭连接
        indexedDB.open("modelList", db.version + 1).onupgradeneeded = function(e) {
            const db = e.target.result;
            db.createObjectStore("model", { autoIncrement: true });
            db.close(); // 使用后关闭连接
        };
    }
}


const app = createApp(App)
    // 注册图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
window.router = router;
app.use(router)
    // app.use(ElementPlus)
app.use(ElementPlus, {
    locale: zhCn,
})
app.use(pinia);
app.use(lazy);
import useStore from "@store"
const { allProps,shopStore } = useStore()
// await allProps.fetchAllProps()
// 设置分件属性默认值
allProps.initDefaultProps()
await shopStore.init();


// const appStore = useAppStore();
// appStore.fetchAllProps();  // 在应用启动时调用
// pinia.use(({ store }) => {
//   if (store.$id === 'app') {
//     console.log(911,store)
//     store.fetchAllProps();
//   }
// });

const version = '3.1'
app.provide("version", version)
app.directive('v31-hide', el => {
    if (version == '3.1') {
        el.style.display = 'none'
    }
    // console.log(el,88181)
})

app.mount('#app')




window.addEventListener('clearStorageEvent', () => {
    clearStoragePreservingRememberedLogin();
    location.reload()
});


const bc = new BroadcastChannel('clear-storage-channel');
bc.onmessage = (event) => {
    if (event.data === 'clear') {
        clearStoragePreservingRememberedLogin();
        location.reload()

    }
};
